import Cookies from 'js-cookie'
import { mapActions, mapState, mapGetters } from 'vuex'
/**
 * Handle login / registration submit action
 */
export default {
  props: {
    /**
     * Fallback redirect url
     */
    redirectUrl: {
      type: String,
    },
    /**
     * Redirect url for normal members
     */
    redirectMember: {
      type: String,
    },
    /**
     * Redirect url for select members
     */
    redirectSelect: {
      type: String,
    },
    /**
     * Redirect url for elite members
     */
    redirectElite: {
      type: String,
    },
    /**
     * Redirect url for resident members
     */
    redirectResidences: {
      type: String,
    },
  },
  computed: {
    ...mapState('auth', ['isRegisterPending', 'isLoginPending']),
    ...mapState('global', ['lang']),
    ...mapState(['isHsia']),
  },
  watch: {
    isRegisterPending(val) {
      if (this.authType === 'register') {
        this.isLoading = val
        this.form.find('input, select, textarea').prop('disabled', val)
        this.$emit('loading', val)
      }
    },
    isLoginPending(val) {
      if (this.authType === 'login') {
        this.isLoading = val
        this.form.find('input, select, textarea').prop('disabled', val)
        this.$emit('loading', val)
      }
    },
  },
  methods: {
    ...mapActions('auth', ['register', 'login']),
    async submitAction(data) {
      let response = {}

      if ('username' in data) data.username = data.username.trim()
      if (this.authType === 'login') {
        response = await this.login(data)
      } else if (this.authType === 'register') {
        response = await this.register(data)
      }
      if (this.redirectUrl && !this.isHsia) {
        const redirectUrl = this.transformRedirectUrl(
          this.redirectUrl,
          response.profile
        )
        // To cancel redirect return null from the transformRedirectUrl method
        if (redirectUrl) {
          const separator = redirectUrl.includes('?') ? '&' : '?'
          const uniqueParam = Date.now().toString().slice(-6)

          window.location.href = `${redirectUrl}${separator}rui=${uniqueParam}`
        } else {
          window.location.href = `/${this.lang}&rdLoginFB`
        }
      }
      return response
    },
    transformRedirectUrl(url, data) {
      let redirectUrlQueryString = new URLSearchParams(window.location.search)
      redirectUrlQueryString = redirectUrlQueryString.get('returnUrl') || false
      if (
        redirectUrlQueryString
        && !(
          this.redirectMember?.endsWith(redirectUrlQueryString)
          || this.redirectElite?.endsWith(redirectUrlQueryString)
          || this.redirectResidences?.endsWith(redirectUrlQueryString)
          || this.redirectSelect?.endsWith(redirectUrlQueryString)
        )
      ) {
        return redirectUrlQueryString
      }
      if (data.loyalLevel) {
        let redirectUrl = url
        const { loyalLevel } = data
        if (
          (loyalLevel === 'FM' || loyalLevel === 'PE')
          && this.redirectMember
        ) {
          redirectUrl = this.redirectMember
        }
        else if (
          (loyalLevel === 'FS')
          && this.redirectSelect
        ) {
          redirectUrl = this.redirectSelect
        }
        else if (
          (loyalLevel === 'FE'
            || loyalLevel === 'FE+'
            || loyalLevel === 'PER')
          && this.redirectElite
        ) {
          redirectUrl = this.redirectElite
        } else if (
          (loyalLevel === 'FR'
            || loyalLevel === 'FER+'
            || loyalLevel === 'FER')
          && this.redirectResidences
        ) {
          redirectUrl = this.redirectResidences
        }
        return redirectUrl
      }
      return url
    },
  },
}
